<script setup lang="ts">
// Organizer/participant auth state is resolved lazily by the router guard
// (see router/index.ts), only for routes whose meta actually needs it. This
// keeps fully public pages (homepage, docs, public event pages, etc.) from
// issuing an unauthenticated /api/v1/auth/user probe on every load.
</script>

<template>
  <RouterView
    :key="`${$route.params['eventSlug'] ?? ''}-${$route.params['editionSlug'] ?? ''}-${$route.params['raceSlug'] ?? ''}-${$route.params['galleryId'] ?? ''}`"
  />
</template>
